// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hc-ui .person_notes_drawer_note_form .grid--row{margin-bottom:11px}.hc-ui .person_notes_drawer_note_form_action_buttons{display:flex;flex-direction:row;justify-content:flex-end}@media screen and (min-width: 865px){.hc-ui .person_notes_drawer_note_form .grid--row{margin-bottom:0}}\n", ""]);
// Exports
module.exports = exports;
